class FireboltMetricsService {
  init() {}
}

export default new FireboltMetricsService();
